// routes/constant.js

// ============= STATIC ROUTES =============
export const HOME_ROUTE = "/";
export const PRIVACY_ROUTE = "/privacy-policy";
export const TERMS_ROUTE = "/terms";
export const FAQ_ROUTE = "/faqs";
export const CONTACT_ROUTE = "/contact-us";
export const PROFILE_ROUTE = "/profile";
export const ORDER_ROUTE = "/orders";
export const LOGIN_ROUTE = "/login";
export const ABOUT_ROUTE = "/about-us";
export const REQUEST_CONFIRMATION_ROUTE = "/request-confirmation";
export const PAGE_NOT_FOUND_ROUTE = "*";
export const SELL_ONLINE_ROUTE = "/sell-online";
export const BUY_ONLINE_ROUTE = "/buy-online";

// ============= BASE PATHS =============
export const SELL_USED_ONLINE_BASE = "/sell-used-online";
export const SELL_USED_ONLINE_CITY_BASE = "/sell-used-online/in";

// ============= ROUTE PATTERNS (Without City) =============
export const CATEGORY_ROUTE_PATTERN = "/sell-used-online/:categorySlug";
export const BRAND_ROUTE_PATTERN = "/sell-used-online/:categorySlug/:brandSlug";
export const PRODUCT_ROUTE_PATTERN = "/sell-used-online/:categorySlug/:brandSlug/:productSlug";
export const VARIANT_ROUTE_PATTERN = "/sell-used-online/:categorySlug/:brandSlug/:productSlug/:variantSlug";
export const SELL_DEVICE_ROUTE_PATTERN = "/sell-used-online/:categorySlug/:brandSlug/:productSlug/:variantSlug/sell";
export const CALCULATOR_ROUTE_PATTERN = "/sell-used-online/:categorySlug/:brandSlug/:productSlug/:variantSlug/check-price";

// ============= ROUTE PATTERNS (With City) =============
export const CITY_CATEGORY_ROUTE_PATTERN = "/sell-used-online/in/:citySlug/:categorySlug";
export const CITY_BRAND_ROUTE_PATTERN = "/sell-used-online/in/:citySlug/:categorySlug/:brandSlug";
export const CITY_PRODUCT_ROUTE_PATTERN = "/sell-used-online/in/:citySlug/:categorySlug/:brandSlug/:productSlug";
export const CITY_VARIANT_ROUTE_PATTERN = "/sell-used-online/in/:citySlug/:categorySlug/:brandSlug/:productSlug/:variantSlug";

// ============= ROUTE GENERATORS (Without City) =============
export const CATEGORY_ROUTE = (categorySlug) => {
  return `/sell-used-online/${categorySlug}`;
};

export const BRAND_ROUTE = (categorySlug, brandSlug) => {
  return `/sell-used-online/${categorySlug}/${brandSlug}`;
};

export const PRODUCT_ROUTE = (categorySlug, brandSlug, productSlug) => {
  return `/sell-used-online/${categorySlug}/${brandSlug}/${productSlug}`;
};

export const VARIANT_ROUTE = (categorySlug, brandSlug, productSlug, variantSlug) => {
  return `/sell-used-online/${categorySlug}/${brandSlug}/${productSlug}/${variantSlug}`;
};

export const SELL_DEVICE_ROUTE = (categorySlug, brandSlug, productSlug, variantSlug) => {
  return `/sell-used-online/${categorySlug}/${brandSlug}/${productSlug}/${variantSlug}/sell`;
};

export const CALCULATOR_ROUTE = (categorySlug, brandSlug, productSlug, variantSlug) => {
  return `/sell-used-online/${categorySlug}/${brandSlug}/${productSlug}/${variantSlug}/check-price`;
};

// ============= ROUTE GENERATORS (With City) =============
export const CITY_CATEGORY_ROUTE = (citySlug, categorySlug) => {
  return `/sell-used-online/in/${citySlug}/${categorySlug}`;
};

export const CITY_BRAND_ROUTE = (citySlug, categorySlug, brandSlug) => {
  return `/sell-used-online/in/${citySlug}/${categorySlug}/${brandSlug}`;
};

export const CITY_PRODUCT_ROUTE = (citySlug, categorySlug, brandSlug, productSlug) => {
  return `/sell-used-online/in/${citySlug}/${categorySlug}/${brandSlug}/${productSlug}`;
};

export const CITY_VARIANT_ROUTE = (citySlug, categorySlug, brandSlug, productSlug, variantSlug) => {
  return `/sell-used-online/in/${citySlug}/${categorySlug}/${brandSlug}/${productSlug}/${variantSlug}`;
};
